// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ACCOUNT_OWNER = '/account';
const ROOTS_ADMIN = '/admin';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  wizard: path(ROOTS_AUTH, '/wizard'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'), // Force password reset (cognito)
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'), // Forgot password
  newPassword: path(ROOTS_AUTH, '/new-password'), // For admin-created users first login
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  // ROOT 
  root: ROOTS_DASHBOARD,

  // GENERAL
  general: {
    overview: path(ROOTS_DASHBOARD, '/overview'),
    faq: path(ROOTS_DASHBOARD, '/faq'),
    documentation: path(ROOTS_DASHBOARD, '/documentation'),
  },

  // CREATION 
  creation: {
    root: path(ROOTS_DASHBOARD, '/creation'),
    projects: path(ROOTS_DASHBOARD, '/creation/projects'), // Table
    loadouts: (name) => path(ROOTS_DASHBOARD, `/creation/projects/${name}`), // Table based on previous table selection
    progress: path(ROOTS_DASHBOARD, '/creation/progress'),
    review: path(ROOTS_DASHBOARD, '/creation/review'),
    approved: path(ROOTS_DASHBOARD, '/creation/approved'),
  },

  // UPLOAD 3D
  upload: {
    root: path(ROOTS_DASHBOARD, '/upload'),
    // ecommerce: path(ROOTS_DASHBOARD, '/upload/ecommerce'),
    // view: (product) => path(ROOTS_DASHBOARD, `/upload/ecommerce/${product}`),
    model: path(ROOTS_DASHBOARD, '/upload/model'),
  },

  // CREATE 3D 
  create: {
    root: path(ROOTS_DASHBOARD, '/create'),
    threeD: path(ROOTS_DASHBOARD, '/create/project'),
    products: (name) => path(ROOTS_DASHBOARD, `/create/project/${name}/products`), // New selfservice creation route
    loadouts: (name) => path(ROOTS_DASHBOARD, `/create/project/${name}/loadouts`),
    complete: (name) => path(ROOTS_DASHBOARD, `/create/project/${name}/complete`),
    review: (name) => path(ROOTS_DASHBOARD, `/create/project/${name}/review`), 
    cart: (name) => path(ROOTS_DASHBOARD, `/create/project/${name}/cart`), // Invoice route
    ecommerce: path(ROOTS_DASHBOARD, '/create/project'),
  },

  // Ecommerce
  ecommerce: {
    root: path(ROOTS_DASHBOARD, '/ecommerce'),
    library: path(ROOTS_DASHBOARD, '/ecommerce/library'),
    view: (product) => path(ROOTS_DASHBOARD, `/ecommerce/${product}`)
  },

  // ALL MODELS PAGE
  modelLibrary: {
    root: path(ROOTS_DASHBOARD, '/models'),
    all: path(ROOTS_DASHBOARD, '/models/all'),
    view: (name) => path(ROOTS_DASHBOARD, `/models/${name}`),
  },

  // CHAT WINDOW
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },

  // ACCOUNT SETTINGS
  account: {
    root: path(ROOTS_DASHBOARD, '/account'),
    billing: path(ROOTS_DASHBOARD, '/account/billing'),
    general: path(ROOTS_DASHBOARD, '/account/general'),
    notifications: path(ROOTS_DASHBOARD, '/account/notifications'),
    social: path(ROOTS_DASHBOARD, '/account/social'),
    password: path(ROOTS_DASHBOARD, '/account/password'),
    new: path(ROOTS_DASHBOARD, '/account/new'),
    list: path(ROOTS_DASHBOARD, '/account/list'),
    cards: path(ROOTS_DASHBOARD, '/account/cards'),
    profile: path(ROOTS_DASHBOARD, '/account/profile'),
    account: path(ROOTS_DASHBOARD, '/account/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/account/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/account/reece-chung/edit`),
    team_members: path(ROOTS_DASHBOARD, '/account/team-members'),
  },

  // STORE SETTINGS
  store: {
    root: path(ROOTS_DASHBOARD, '/store'),
    overview: path(ROOTS_DASHBOARD, '/store/overview'),
  },

  // ANALYTICS ROUTES
  analytics: {
    root: path(ROOTS_DASHBOARD, '/analytics'),
    overview: path(ROOTS_DASHBOARD, '/analytics/overview')
  },

  // Store Admin ROUTES
  admin: {
    root: path(ROOTS_DASHBOARD, '/store-admin/micro-site-overview'),
    micro_overview: path(ROOTS_DASHBOARD, '/store-admin/micro-site-overview'),
    micro_builder: path(ROOTS_DASHBOARD, '/store-admin/micro-site-builder'),
    micro_view: (micrositeid) => path(ROOTS_DASHBOARD, `/store-admin/micro-site-builder/${micrositeid}`),
  },
};

// ADMIN ROUTES
export const PATH_ACCOUNT_OWNER = {
  root: ROOTS_ACCOUNT_OWNER,
  general: {
    accountStores: path(ROOTS_ACCOUNT_OWNER, '/account-stores'),
  },
}

// ADMIN ROUTES
export const PATH_ADMIN = {
  root: ROOTS_ADMIN,

  // Shallow routes
  adminOverview: path(ROOTS_ADMIN, '/admin-overview'),
  adminForbiddenRoom: path(ROOTS_ADMIN, '/forbidden-room'),
  stores: {
    root: path(ROOTS_ADMIN, '/stores'),
    all: path(ROOTS_ADMIN, '/stores/all'),
    active: path(ROOTS_ADMIN, '/stores/active'),
    projects: path(ROOTS_ADMIN, '/stores/projects'),
    loadouts: path(ROOTS_ADMIN, '/stores/loadouts'),
  },
  shopifyStores: {
    root: path(ROOTS_ADMIN, '/shopify-stores'),
    allShopify: path(ROOTS_ADMIN, '/shopify-stores/all'),
    allActiveShopify: path(ROOTS_ADMIN, '/shopify-stores/all-active-shopify-stores'),
    allPendingShopify: path(ROOTS_ADMIN, '/shopify-stores/all-pending-shopify-stores'),
    viewAll: (store) => path(ROOTS_ADMIN, `/shopify-stores/default/${store}`),
    viewActive: (store) => path(ROOTS_ADMIN, `/shopify-stores/active/${store}`)
  },
  customStores: {
    root: path(ROOTS_ADMIN, '/custom-stores'),
    allCustom: path(ROOTS_ADMIN, '/custom-stores/all'),
    viewCustom: (store) => path(ROOTS_ADMIN, `/custom-stores/${store}`),
  },
  bigcommerceStores: {
    root: path(ROOTS_ADMIN, '/bigcommerce-stores'),
    allBigcommerce: path(ROOTS_ADMIN, '/bigcommerce-stores/all'),
    viewBigcommerce: (store) => path(ROOTS_ADMIN, `/bigcommerce-stores/${store}`),
  }
}

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';